import Check from './src/Check';
export default Check;